var app = angular.module('forestDirectives', []);

app.directive('forceInt', function(){
    return {
        restrict: 'A',

        require: 'ngModel',

        link: function(scope, elem, attr, ctrl) {

            ctrl.$parsers.unshift(function(value) {
                // test and set the validity after update.
                return parseInt(value);
            });
        }
    };
});

app.directive('regexValidate', function() {
    return {
        // restrict to an attribute type.
        restrict: 'A',
        
        // element must have ng-model attribute.
        require: 'ngModel',
        
        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function(scope, elem, attr, ctrl) {
            
            //get the regex flags from the regex-validate-flags="" attribute (optional)
            var flags = attr.regexValidateFlags || '';
            
            // create the regex obj.
            var regex = new RegExp(attr.regexValidate, flags);            
                        
            // add a parser that will process each time the value is 
            // parsed into the model when the user updates it.
            ctrl.$parsers.unshift(function(value) {
                // test and set the validity after update.
                var valid = regex.test(value);
                ctrl.$setValidity('regexValidate', valid);
                
                // if it's valid, return the value to the model, 
                // otherwise return undefined.
                return valid ? value : undefined;
            });
            
            // add a formatter that will process each time the value 
            // is updated on the DOM element.
            ctrl.$formatters.unshift(function(value) {
                // validate.
                ctrl.$setValidity('regexValidate', regex.test(value));
                
                // return the value or nothing will be written to the DOM.
                return value;
            });
        }
    };
});

app.directive('sbKoefValidate', function(_) {
    return {
        // restrict to an attribute type.
        restrict: 'A',

        // element must have ng-model attribute.
        require: 'ngModel',

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function(scope, elem, attr, ctrl) {

            /**
             * Do nothing if this validator is used outside SB m10
             */
            if(!scope.userInput && !scope.userInput.m10_items){
                return;
            }

            // add a parser that will process each time the value is
            // parsed into the model when the user updates it.
            ctrl.$parsers.unshift(function(value) {

                var sum = scope.koefSum;

                var valid = 0 < value && value <= (10 - sum);

                ctrl.$setValidity('koef', valid);

                // if it's valid, return the value to the model,
                // otherwise return undefined.
                return valid ? value : undefined;
            });

            // add a formatter that will process each time the value
            // is updated on the DOM element.
            ctrl.$formatters.unshift(function(value) {
                // validate.

                //console.log('$formatters: ', value);

                /*
                var valid = 0 < value && value < 10;

                ctrl.$setValidity('sbKoefValidate', valid);

                // return the value or nothing will be written to the DOM.
                return value > 10 ? 10 : value;*/
            });
        }
    };
});

app.directive('showErrors', function() {
    return {
        restrict: 'A',
        require:  '^form',
        link: function (scope, el, attrs, formCtrl) {

            // find the text box element, which has the 'name' attribute
            var inputEl   = el[0].querySelector("[name]");

            // convert the native text box element to an angular element
            var inputNgEl = angular.element(inputEl);
            // get the name on the text box so we know the property to check
            // on the form controller
            var inputName = inputNgEl.attr('name');

            // only apply the has-error class after the user leaves the text box
            inputNgEl.bind('blur', function() {
                el.toggleClass('has-error', formCtrl[inputName].$invalid);
            })
        }
    }
});

app.directive('forestValidate', function() {
    return {
        // restrict to an attribute type.
        restrict: 'A',
        
        // element must have ng-model attribute.
        require: 'ngModel',
        
        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function(scope, elem, attr, ctrl) {
            
            var validationType = attr.forestValidate;
            
            if(validationType === "treeHeight"){
            
                ctrl.$parsers.unshift(function(value) {
                    // test and set the validity after update.
                    
                    var valid = (value ? value : 0) < 100;
                    
                    ctrl.$setValidity('forestValidate', valid);

                    //console.log("checking for tree height validation: " + value);
                    // if it's valid, return the value to the model, 
                    // otherwise return undefined.
                    return valid ? value : undefined;
                }); 

                // add a formatter that will process each time the value 
                // is updated on the DOM element.
                ctrl.$formatters.unshift(function(value) {
                    // validate.
                    var valid = (value ? value : 0) < 100;
                    
                    ctrl.$setValidity('forestValidate', valid);

                    // return the value or nothing will be written to the DOM.
                    return value;
                });
            } else if(false) {
                
            }
        }
    };
});

app.directive('initDatepicker', function() {
    return {
        restrict: 'A',
        link: function(scope, elem, attr) {
          
          $(".input-daterange").datepicker({autoclose: true, format: "yyyy-mm-dd"});
          
        }
    };
});

//TODO: Need to add $watch for target element in case element is not added to 
//DOM at time when lock-next is running.

app.directive('lockNexta', ['$parse', '$timeout', function($parse, $timeout) {
    return {
        restrict: 'A',
        require: ['ngModel'],
        link: function(scope, element, attrs, ctrls) {
          //if(ctrls.$name === "koordinatebi_zona"){
             //console.log(ctrls.$modelValue);
          //}
          //console.log(ctrls.name == "zona" ? : ctrls.name);
          
          function isDisabled(element){
            return element.attr('disabled') ? element.attr('disabled') : false;
          }
          
          var model=ctrls[0], form=ctrls[1];
          
          var nextinput = $(":input:eq(" + ($(":input").index(element) + 1) + ")");
          
          //find next input, on entire document
          //TODO: find a way do search only inside form
          var lockInputs = {};
          
          if(attrs.lockNext !== ""){
            if(!isNaN(parseInt(attrs.lockNext.charAt(0)))){
              var quantity = parseInt(attrs.lockNext);
              lockInputs = $(":input").slice($(":input").index(element) + 1, $(":input").index(element) + 1 + quantity);
            }else{
              //console.log($.map(attrs.lockNext.split(' '), function(el){return '[name='+el+']';}).join());
              lockInputs = $($.map(attrs.lockNext.split(' '), function(el){return '[name='+el+']';}).join());
            }
          }else{
            lockInputs = nextinput;
          }
          
          //FIXME: Maybe choosen have event when it is ready to use instead of timeout
          //To wait for choosen inputs to generate $timeout is required
          if($(element).is('[chosen]')){
            $timeout(bindTabControl, 0);
          }else{
            bindTabControl();
          }
          
          function bindTabControl(){
            
            obj = $(element).is('[chosen]') ? element.next('.chosen-container') : element;
            obj.bind("keydown", function(event) {
                if(event.which === 9 && isDisabled(nextinput) && !event.shiftKey) {
                    event.preventDefault();
                }
              //console.log(JSON.stringify($(nextinput).attr('id')));
            });
          }
          
          scope.amIActive = function(){
            return isDisabled(element);
          }
          
          scope.$watch(scope.amIActive, listener);
          
           scope.next = function(){
                return model.$valid;
            }
           
          scope.$watch(scope.next, listener);
          
          scope.$on('$destroy', function() {
            $.map(lockInputs, function(nextinput, index){
              $(nextinput).attr('disabled', 'disabled').trigger("chosen:updated");
            });
            
            $.map(lockInputs, function(nextinput, index){
                    if($(nextinput).is('[chosen]')){ 
                       $(nextinput).trigger("chosen:updated") 
                     }
            });
          });
          
          function listener(newValue, oldValue){
              
                if(!('required' in attrs)) return;
              
                //Dirty prevented, enables if data is filled 
                //programatically i.e. from server
                //if (model.$valid && model.$dirty && !isDisabled(element))
                if (model.$valid && !isDisabled(element))
                {
                  $.map(lockInputs, function(nextinput, index){
                    $(nextinput).removeAttr('disabled');
                  });
                } else {
                  $.map(lockInputs, function(nextinput, index){
                    $(nextinput).attr('disabled', 'disabled').trigger("chosen:updated");
                  });
                }
            
                //Make it compatible with chosen  
            
                $.map(lockInputs, function(nextinput, index){
                    if($(nextinput).is('[chosen]')){ 
                       $(nextinput).trigger("chosen:updated") 
                     }
                });
          }
        }
    }
}]);

app.directive('confirmOnExit', function($rootScope) {

    return {
        link: function($scope, elem, attrs) {

            window.onbeforeunload = function(){
                if ($scope[attrs.name].$dirty) {
                    return "ამ ფორმაში შეყვანილი ინფორმაცია დაიკარგება გსურთ გაგრძელება?";
                }
            };
            $scope.$on('$stateChangeStart', function(event, next, current) {
                if ($scope[attrs.name].$dirty) {
                    if(!confirm("ამ ფორმაში შეყვანილი ინფორმაცია დაიკარგება გსურთ გაგრძელება?")) {
                        event.preventDefault();
                    }
                }

                /**
                 * TODO: Make this centralized, so that $stateChangePrevented is always broadcasted.
                 */

                if(event.defaultPrevented){
                    $rootScope.$broadcast('$stateChangePrevented', next, current);
                    $scope.prevented = event.defaultPrevented;
                }
            });
        }
    };
});

app.directive('fixChosenSelects', function($rootScope) {

    return {
        link: function($scope, elem, attrs) {
            var selects = elem.querySelector('select');

            angular.forEach(selects, function(select){
                select.attr('disabled', 'disabled');
            });
        }
    };
});